// // InsideFlashFluency/index.js
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { post as introducingPlusOneSRSMeta } from './BlogPosts/IntroducingPlusOneSRS';
// // Import additional posts similarly

// // Collect your posts in an array
// const posts = [
//   introducingPlusOneSRSMeta,
//   // Add new post metadata objects here
// ];

// export default function InsideFlashFluency() {
//   // Local state for search term and current page
//   // const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);

//   // Number of posts to display per page
//   const pageSize = 5;

//   // Filter posts by the search term (matching title or summary)
//   // const filteredPosts = posts.filter((post) =>
//   //   post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//   //   post.summary.toLowerCase().includes(searchTerm.toLowerCase())
//   // );

//   // Calculate pagination
//   const startIndex = (currentPage - 1) * pageSize;
//   const endIndex = startIndex + pageSize;
//   const paginatedPosts = filteredPosts.slice(startIndex, endIndex);
//   // const totalPages = Math.ceil(filteredPosts.length / pageSize);

//   // Handle page change
//   // const handlePageChange = (pageNumber) => {
//   //   setCurrentPage(pageNumber);
//   // };

//   return (
//     <div className="container mx-auto p-6">
//       {/* Hero or Intro Section */}
//       <div className="mb-6">
//         <h1 className="text-3xl font-bold mb-2">Inside Flash Fluency</h1>
//         <p className="text-gray-700">
//           Welcome to our blog! Here, we share insights, updates, and behind-the-scenes
//           stories about Flash Fluency.  We've got several topics we're looking to shed more light on in the coming months.
//           The goal is to drop a new post every 2 weeks.
//         </p>
//       </div>

//       {/* Search Bar
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search blog posts..."
//           value={searchTerm}
//           onChange={(e) => {
//             setSearchTerm(e.target.value);
//             setCurrentPage(1); // Reset to page 1 on new search
//           }}
//           className="border border-gray-300 p-2 rounded w-full"
//         />
//       </div> */}

//       {/* Posts Listing */}
//       <div className="space-y-4">
//         {paginatedPosts.map((post) => (
//           <div
//             key={post.slug}
//             className="p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
//           >
//             {/* (Optional) Featured Image if available: 
//             <img src={post.image} alt={post.title} className="mb-2 rounded" /> 
//             */}
//             <h2 className="text-2xl font-semibold mb-1">
//               <Link
//                 to={`/inside-flash-fluency/${post.slug}`}
//                 className="text-blue-500 hover:underline"
//               >
//                 {post.title}
//               </Link>
//             </h2>
//             <p className="text-sm text-gray-500 mb-2">{post.date}</p>
//             <p className="text-gray-600 mb-2">{post.summary}</p>
//             <Link
//               to={`/inside-flash-fluency/${post.slug}`}
//               className="text-blue-500 hover:underline"
//             >
//               Read More
//             </Link>
//           </div>
//         ))}

//         {/* If no posts match the search
//         {paginatedPosts.length === 0 && (
//           <p className="text-gray-600">No posts found.</p>
//         )} */}
//       </div>

//       {/* Pagination Controls
//       <div className="flex justify-center mt-6 space-x-2">
//         {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//           <button
//             key={page}
//             onClick={() => handlePageChange(page)}
//             className={`px-3 py-1 rounded ${
//               page === currentPage
//                 ? 'bg-blue-500 text-white'
//                 : 'bg-gray-200 hover:bg-gray-300'
//             }`}
//           >
//             {page}
//           </button>
//         ))}
//       </div> */}
//     </div>
//   );
// }




// InsideFlashFluency/index.js
import React from 'react';
import { Link } from 'react-router-dom';
import { getPalette } from '../ColorPalette';
import { post as introducingPlusOneSRSMeta } from './BlogPosts/IntroducingPlusOneSRS';
import backdropImage from '../images/BackdropNight.png';

// Collect your posts in an array
const posts = [
  introducingPlusOneSRSMeta,
  // Add new post metadata objects here
];

export default function InsideFlashFluency() {
  const colors = getPalette('dark');
  
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${backdropImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundColor: colors.background,
        display: 'flex',
        justifyContent: 'center',
        padding: '40px 24px'
      }}
    >
      <div style={{ maxWidth: '900px', width: '100%' }}>
        {/* Hero or Intro Section */}
        <div
          style={{
            backgroundColor: colors.container,
            borderRadius: '16px',
            boxShadow: `0 4px 16px ${colors.shadow}`,
            padding: '32px',
            marginBottom: '24px',
            border: `1px solid ${colors.borderSilver}`
          }}
        >
          <h1
            style={{
              fontSize: '32px',
              fontWeight: '800',
              marginBottom: '12px',
              color: colors.text
            }}
          >
            Inside Flash Fluency
          </h1>
          <p
            style={{
              color: colors.text,
              opacity: 0.85,
              fontSize: '16px',
              lineHeight: '1.6'
            }}
          >
            Welcome to our blog — a space where we share insights, updates, and behind-the-scenes stories from building Flash Fluency. 
          </p>
        </div>

        {/* Posts Listing */}
        <div className="space-y-4">
          {posts.map((post) => (
            <div
              key={post.slug}
              style={{
                padding: '24px',
                backgroundColor: colors.container,
                borderRadius: '12px',
                boxShadow: `0 2px 8px ${colors.shadow}`,
                border: `1px solid ${colors.borderSilver}`,
                transition: 'all 0.2s ease'
              }}
              className="hover:shadow-lg"
            >
              <h2
                style={{
                  fontSize: '24px',
                  fontWeight: '600',
                  marginBottom: '8px'
                }}
              >
                <Link
                  to={`/inside-flash-fluency/${post.slug}`}
                  style={{
                    color: colors.progressBarFg,
                    textDecoration: 'none'
                  }}
                  className="hover:underline"
                >
                  {post.title}
                </Link>
              </h2>
              <p
                style={{
                  fontSize: '14px',
                  color: colors.text,
                  opacity: 0.6,
                  marginBottom: '12px'
                }}
              >
                {post.date}
              </p>
              <p
                style={{
                  color: colors.text,
                  opacity: 0.85,
                  marginBottom: '12px',
                  fontSize: '15px',
                  lineHeight: '1.6'
                }}
              >
                {post.summary}
              </p>
              <Link
                to={`/inside-flash-fluency/${post.slug}`}
                style={{
                  color: colors.progressBarFg,
                  textDecoration: 'none',
                  fontSize: '15px',
                  fontWeight: '500'
                }}
                className="hover:underline"
              >
                Read More →
              </Link>
            </div>
          ))}

          {posts.length === 0 && (
            <div
              style={{
                padding: '24px',
                backgroundColor: colors.container,
                borderRadius: '12px',
                border: `1px solid ${colors.borderSilver}`,
                textAlign: 'center'
              }}
            >
              <p style={{ color: colors.text, opacity: 0.7 }}>
                No posts found. Check back soon!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}